module.exports = __webpack_public_path__ + "static/ride-story-right-25d1a4a68f37138eab1d1adba85fe5a3.png";